import { FETCH_INITIAL_HISTORY_REQUEST, FETCH_INITIAL_HISTORY_FAILURE, FETCH_INITIAL_HISTORY_SUCCESS, FETCH_NEXT_HISTORY_REQUEST, FETCH_NEXT_HISTORY_FAILURE, FETCH_NEXT_HISTORY_SUCCESS, ADD_NEW_HISTORY_ITEM, } from './history-actions';
import { createLocalHistoryRevision } from './history-utils';
export const historyReducer = (state, actions) => {
    switch (actions.type) {
        case ADD_NEW_HISTORY_ITEM: {
            const { commentId, comment, owner } = actions.payload;
            const commentHistoryState = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        isPending: false,
                        nextCursor: commentHistoryState?.nextCursor ?? null,
                        items: [
                            createLocalHistoryRevision(comment, owner),
                            ...(commentHistoryState?.items ?? []),
                        ],
                    },
                },
            };
        }
        case FETCH_INITIAL_HISTORY_REQUEST:
        case FETCH_NEXT_HISTORY_REQUEST: {
            const { commentId } = actions.payload;
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        nextCursor: state.historyById[commentId]?.nextCursor ?? null,
                        items: state.historyById[commentId]?.items ?? [],
                        isPending: true,
                    },
                },
            };
        }
        case FETCH_NEXT_HISTORY_FAILURE:
        case FETCH_INITIAL_HISTORY_FAILURE: {
            const { commentId } = actions.payload;
            const commentHistory = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        items: commentHistory?.items ?? [],
                        nextCursor: commentHistory?.nextCursor ?? null,
                        isPending: false,
                    },
                },
            };
        }
        case FETCH_NEXT_HISTORY_SUCCESS: {
            const { commentId, nextCursor, history } = actions.payload;
            const currentItems = state.historyById[commentId]?.items ?? [];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        items: [...currentItems, ...history],
                        nextCursor,
                        isPending: false,
                    },
                },
            };
        }
        case FETCH_INITIAL_HISTORY_SUCCESS: {
            const { commentId, nextCursor, history } = actions.payload;
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        items: history,
                        nextCursor,
                        isPending: false,
                    },
                },
            };
        }
        default:
            return state;
    }
};
//# sourceMappingURL=history-reducer.js.map